import moment from 'moment-timezone';

import { DateRangeValueType } from '@core/date-range-types';

const AllDateRangeMap: Record<DateRangeValueType, number | null> = {
  [DateRangeValueType.Today]: 1,
  [DateRangeValueType.Tomorrow]: 1,
  [DateRangeValueType.NextWeek]: 1,
  [DateRangeValueType.Yesterday]: 1,
  [DateRangeValueType.ThisWeek]: 7,
  [DateRangeValueType.LastWeek]: 7,
  [DateRangeValueType.ThisMonth]: 30,
  [DateRangeValueType.LastMonth]: 30,
  [DateRangeValueType.NextMonth]: 30,
  [DateRangeValueType.ThisQuarter]: 120,
  [DateRangeValueType.LastQuarter]: 120,
  [DateRangeValueType.NextQuarter]: 120,
  [DateRangeValueType.ThisYear]: 365,
  [DateRangeValueType.LastYear]: 365,
  [DateRangeValueType.NextYear]: 365,
  [DateRangeValueType.Last7Days]: 7,
  [DateRangeValueType.Last14Days]: 14,
  [DateRangeValueType.Last20Days]: 20,
  [DateRangeValueType.Last30Days]: 30,
  [DateRangeValueType.Last60Days]: 60,
  [DateRangeValueType.Last90Days]: 90,
  [DateRangeValueType.Last365Days]: 365,
  [DateRangeValueType.AllTime]: Number.POSITIVE_INFINITY,
  [DateRangeValueType.Range]: null,
  [DateRangeValueType.Exact]: 1,
  [DateRangeValueType.Custom]: null,
  [DateRangeValueType.WithinLast]: null,
  [DateRangeValueType.WithinNext]: null,
};

const DateRangeToDays: Record<string, number | null> = AllDateRangeMap;

export const getDaysCountInDateRange = (
  // type is very wide to allow for usage in all contexts and always fall back to start/end date
  dateRange: string | DateRangeValueType | null,
  startDate?: string | null,
  endDate?: string | null,
) => {
  if (dateRange && DateRangeToDays[dateRange]) {
    return DateRangeToDays[dateRange];
  }
  if (!startDate) {
    return 0;
  }
  const endDateNormalized = endDate || new Date().toISOString();

  return moment(endDateNormalized).diff(moment(startDate), 'days');
};
